import { ArrowRight, MessageCircle } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { Reveal } from "@/components/Reveal";

export const FinalCTA = () => (
    <section id="cta" data-testid="final-cta-section" className="relative overflow-hidden bg-brand-deep py-28 sm:py-36">
        <div className="bg-blueprint-dark pointer-events-none absolute inset-0 opacity-70 [mask-image:radial-gradient(70%_70%_at_50%_50%,black,transparent)]" />

        <div className="cta-glow pointer-events-none absolute right-[-8%] top-1/2 hidden h-[560px] w-[560px] -translate-y-1/2 rounded-full lg:block" />

        <img
            src="/brand/genie.png"
            alt="Reno Genie mascot"
            data-testid="cta-genie-static"
            className="genie-static absolute right-[8%] top-1/2 hidden w-64 -translate-y-1/2 drop-shadow-[0_26px_34px_rgba(0,0,0,0.4)] lg:block"
        />

        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal>
                <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.24em] text-brand-gold">
                    05 — Your Wish
                </p>
                <h2
                    data-testid="cta-headline"
                    className="max-w-2xl font-display text-4xl font-semibold leading-[1.04] tracking-tighter text-white sm:text-5xl lg:text-6xl"
                >
                    Ready to Make Your <span className="italic text-brand-gold">Wish</span> Real?
                </h2>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
                    Tell us what you have in mind. Reno Genie will help bring your renovation vision to life — from the
                    first sketch to the final sparkle.
                </p>
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <button
                        type="button"
                        data-testid="cta-primary-button"
                        className="group inline-flex items-center gap-2.5 rounded-full bg-brand-gold px-8 py-4 text-sm font-bold text-brand-deep transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_44px_rgba(253,185,39,0.4)]"
                    >
                        Start Your Renovation
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </button>
                    <button
                        type="button"
                        onClick={() => scrollToId("#contact")}
                        data-testid="cta-secondary-button"
                        className="inline-flex items-center gap-2.5 rounded-full border border-white/25 px-8 py-4 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-1 hover:border-white hover:bg-white hover:text-brand-deep"
                    >
                        <MessageCircle className="h-4 w-4" />
                        Talk to Us
                    </button>
                </div>
            </Reveal>
        </div>
    </section>
);
